import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

interface DeleteOTCPrescriptionResponse {
  bundle: object;
}

export const useDeleteOTCPrescription = ({
  patientId,
  encounterId,
  carePlanId,
  carePlanActivityId,
}: {
  patientId: string;
  encounterId: string;
  carePlanId: string;
  carePlanActivityId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<DeleteOTCPrescriptionResponse, void>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.Prescriptions.DELETE_OTC(
        patientId,
        encounterId,
        carePlanActivityId,
      ),
      mutationFn: () => {
        return axiosInstance.delete(
          `/rx/prescriptions/otc/${carePlanActivityId}`,
          { params: { care_plan_id: carePlanId } },
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Prescriptions.DEFAULT(
            patientId,
            encounterId,
          ),
        });

        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId,
          }),
        });
      },
    },
  });
};
